// Generated from OlaCore's Enum_SYS_Country_Location and CountryLocationCodes: the number
// Core stores for each country, and its ISO 3166-1 code. The numbers never change.

/** Core's Enum_SYS_Country_Location.Unknown: no country (Core then uses the pin's). */
export const UNKNOWN_COUNTRY = 1;

export const COUNTRY_CODES: ReadonlyArray<readonly [value: number, code: string]> = [
  [2, "GB"],
  [3, "SE"],
  [4, "US"],
  [5, "AD"],
  [6, "AE"],
  [7, "AF"],
  [8, "AG"],
  [9, "AI"],
  [10, "AL"],
  [11, "AM"],
  [12, "AO"],
  [13, "AQ"],
  [14, "AR"],
  [15, "AS"],
  [16, "AT"],
  [17, "AU"],
  [18, "AW"],
  [19, "AX"],
  [20, "AZ"],
  [21, "BA"],
  [22, "BB"],
  [23, "BD"],
  [24, "BE"],
  [25, "BF"],
  [26, "BG"],
  [27, "BH"],
  [28, "BI"],
  [29, "BJ"],
  [30, "BL"],
  [31, "BM"],
  [32, "BN"],
  [33, "BO"],
  [34, "BQ"],
  [35, "BR"],
  [36, "BS"],
  [37, "BT"],
  [38, "BV"],
  [39, "BW"],
  [40, "BY"],
  [41, "BZ"],
  [42, "CA"],
  [43, "CC"],
  [44, "CD"],
  [45, "CF"],
  [46, "CG"],
  [47, "CH"],
  [48, "CI"],
  [49, "CK"],
  [50, "CL"],
  [51, "CM"],
  [52, "CN"],
  [53, "CO"],
  [54, "CR"],
  [55, "CU"],
  [56, "CV"],
  [57, "CW"],
  [58, "CX"],
  [59, "CY"],
  [60, "CZ"],
  [61, "DE"],
  [62, "DJ"],
  [63, "DK"],
  [64, "DM"],
  [65, "DO"],
  [66, "DZ"],
  [67, "EC"],
  [68, "EE"],
  [69, "EG"],
  [70, "EH"],
  [71, "ER"],
  [72, "ES"],
  [73, "ET"],
  [74, "FI"],
  [75, "FJ"],
  [76, "FK"],
  [77, "FM"],
  [78, "FO"],
  [79, "FR"],
  [80, "GA"],
  [81, "GD"],
  [82, "GE"],
  [83, "GF"],
  [84, "GG"],
  [85, "GH"],
  [86, "GI"],
  [87, "GL"],
  [88, "GM"],
  [89, "GN"],
  [90, "GP"],
  [91, "GQ"],
  [92, "GR"],
  [93, "GS"],
  [94, "GT"],
  [95, "GU"],
  [96, "GW"],
  [97, "GY"],
  [98, "HK"],
  [99, "HM"],
  [100, "HN"],
  [101, "HR"],
  [102, "HT"],
  [103, "HU"],
  [104, "ID"],
  [105, "IE"],
  [106, "IL"],
  [107, "IM"],
  [108, "IN"],
  [109, "IO"],
  [110, "IQ"],
  [111, "IR"],
  [112, "IS"],
  [113, "IT"],
  [114, "JE"],
  [115, "JM"],
  [116, "JO"],
  [117, "JP"],
  [118, "KE"],
  [119, "KG"],
  [120, "KH"],
  [121, "KI"],
  [122, "KM"],
  [123, "KN"],
  [124, "KP"],
  [125, "KR"],
  [126, "KW"],
  [127, "KY"],
  [128, "KZ"],
  [129, "LA"],
  [130, "LB"],
  [131, "LC"],
  [132, "LI"],
  [133, "LK"],
  [134, "LR"],
  [135, "LS"],
  [136, "LT"],
  [137, "LU"],
  [138, "LV"],
  [139, "LY"],
  [140, "MA"],
  [141, "MC"],
  [142, "MD"],
  [143, "ME"],
  [144, "MF"],
  [145, "MG"],
  [146, "MH"],
  [147, "MK"],
  [148, "ML"],
  [149, "MM"],
  [150, "MN"],
  [151, "MO"],
  [152, "MP"],
  [153, "MQ"],
  [154, "MR"],
  [155, "MS"],
  [156, "MT"],
  [157, "MU"],
  [158, "MV"],
  [159, "MW"],
  [160, "MX"],
  [161, "MY"],
  [162, "MZ"],
  [163, "NA"],
  [164, "NC"],
  [165, "NE"],
  [166, "NF"],
  [167, "NG"],
  [168, "NI"],
  [169, "NL"],
  [170, "NO"],
  [171, "NP"],
  [172, "NR"],
  [173, "NU"],
  [174, "NZ"],
  [175, "OM"],
  [176, "PA"],
  [177, "PE"],
  [178, "PF"],
  [179, "PG"],
  [180, "PH"],
  [181, "PK"],
  [182, "PL"],
  [183, "PM"],
  [184, "PN"],
  [185, "PR"],
  [186, "PS"],
  [187, "PT"],
  [188, "PW"],
  [189, "PY"],
  [190, "QA"],
  [191, "RE"],
  [192, "RO"],
  [193, "RS"],
  [194, "RU"],
  [195, "RW"],
  [196, "SA"],
  [197, "SB"],
  [198, "SC"],
  [199, "SD"],
  [200, "SG"],
  [201, "SH"],
  [202, "SI"],
  [203, "SJ"],
  [204, "SK"],
  [205, "SL"],
  [206, "SM"],
  [207, "SN"],
  [208, "SO"],
  [209, "SR"],
  [210, "SS"],
  [211, "ST"],
  [212, "SV"],
  [213, "SX"],
  [214, "SY"],
  [215, "SZ"],
  [216, "TC"],
  [217, "TD"],
  [218, "TF"],
  [219, "TG"],
  [220, "TH"],
  [221, "TJ"],
  [222, "TK"],
  [223, "TL"],
  [224, "TM"],
  [225, "TN"],
  [226, "TO"],
  [227, "TR"],
  [228, "TT"],
  [229, "TV"],
  [230, "TW"],
  [231, "TZ"],
  [232, "UA"],
  [233, "UG"],
  [234, "UM"],
  [235, "UY"],
  [236, "UZ"],
  [237, "VA"],
  [238, "VC"],
  [239, "VE"],
  [240, "VG"],
  [241, "VI"],
  [242, "VN"],
  [243, "VU"],
  [244, "WF"],
  [245, "WS"],
  [246, "YE"],
  [247, "YT"],
  [248, "ZA"],
  [249, "ZM"],
  [250, "ZW"],
];
